import axios from "@/libraries/axios/axiosConfig";

/** Token needed for this endpoint */
export default async function(qrId, trailerId, trailerCompany, accessToken, qrInstallLocation, browser, location, device, operatingSystem) {
  return await axios({
    method: "post",
    url: `${process.env.VUE_APP_EXT_API_URL}api/admin/qr/associateQrToTrailer`,
    headers: { "X-TacLite-AppToken": `${process.env.VUE_APP_TACLITE_APPTOKEN_VALUE}`, Authorization: `Bearer ${accessToken}` },
    data: {
      qrId: qrId,
      trailerId: trailerId,
      trailerCompany: trailerCompany,
      qrInstallLocation: qrInstallLocation,
      browser: browser,
      location: location,
      device: device,
      operatingSystem: operatingSystem
    }
  }).then(r => r.data)
}